import { render, staticRenderFns } from "./envelope-title.vue?vue&type=template&id=db87734c&scoped=true"
import script from "./envelope-title.vue?vue&type=script&lang=js"
export * from "./envelope-title.vue?vue&type=script&lang=js"
import style0 from "./envelope-title.vue?vue&type=style&index=0&id=db87734c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db87734c",
  null
  
)

export default component.exports